import React from "react";
import Team from "../../components/team/Team";

function TeamPage() {
  return <Team />;
}

export default TeamPage;
